module.exports = "/assets/0419ac28c6896d8b7391e785103ce9b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TK.png
// module id = 1859
// module chunks = 0